import React from 'react';
import customClientConfig from '../../customClientConfig';

// position: 'top' | 'bottom'. Reads topPageText/bottomPageText (raw HTML) plus
// the matching showTopTextOnLandingPage/showBottomTextOnLandingPage flag from
// customClientConfig.js. Renders nothing when the tenant has no text set, or
// when isLandingPage is true and the tenant hasn't opted into showing it there.
const TenantPageText = ({ tenant, position, isLandingPage }) => {
  const clientConfig = customClientConfig[tenant];
  if (!clientConfig) {
    return null;
  }

  const textKey = position === 'top' ? 'topPageText' : 'bottomPageText';
  const showOnLandingKey =
    position === 'top' ? 'showTopTextOnLandingPage' : 'showBottomTextOnLandingPage';

  const html = clientConfig[textKey];
  if (!html) {
    return null;
  }

  if (isLandingPage && !clientConfig[showOnLandingKey]) {
    return null;
  }

  return (
    <div
      className={`tenant-page-text tenant-${position}-text`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default TenantPageText;
